import { fileTypeMap } from './Page/constant';
export function removeHtmlTags(str) {
    return str.replace(/<[^>]*>/g, '');
}
export function removeTagsAndContent(htmlString, tagName) {
    // 构建正则表达式模式，用于匹配开始标签、中间内容和结束标签
    const regex = new RegExp(`<${tagName}[^>]*>.*?</${tagName}>`, 'gsi');

    // 执行替换操作，将匹配到的内容替换为空字符串
    return htmlString.replace(regex, '');
}
export const iconMap = {
    image: 'icon-img',
    ppt: 'icon-ppt',
    pdf: 'icon-pdf',
    word: 'icon-word',
    excel: 'icon-excel',
    html: 'icon-file',
    archive: 'icon-archive',
    script: 'icon-file',
    usual: 'icon-file',
    txt: 'icon-file'
};
export function getTypeBySuffix(ext) {
    const typeMap = {
        ppt: 'ppt',
        pptx: 'ppt',
        jpg: 'image',
        jpeg: 'image',
        png: 'image',
        webp: 'image',
        gif: 'image',
        pdf: 'pdf',
        doc: 'word',
        docx: 'word',
        xls: 'excel',
        xlsx: 'excel',
        csv: 'excel',
        zip: 'archive',
        rar: 'archive',
        js: 'script',
        html: 'html',
        txt: 'txt',
        link: 'link',
        epub: 'epub',
        md: 'md',
        xml: 'xml'
    };
    return typeMap[ext];
}
// 通过文件名名获取类型的函数
export function getFileSuffix(filename) {
    if (!filename) return '';
    const lastDotIndex = filename.lastIndexOf('.');
    if (lastDotIndex === -1) return '';
    return filename.slice(lastDotIndex + 1).toLowerCase();
}
//格式化文件大小
export const formatFileSize = (bytes) => {
    if (typeof bytes !== 'number' || isNaN(bytes) || bytes < 0) {
        return '0KB'; // 无效输入返回 0 KB（不带小数）
    }

    if (bytes < 1024 * 1024) {
        // 小于 1MB，计算 KB
        const kb = bytes / 1024;
        return kb % 1 === 0 ? `${kb}KB` : `${Math.ceil(kb)}KB`;
    } else {
        // 大于或等于 1MB，计算 MB
        const mb = bytes / (1024 * 1024);
        return mb % 1 === 0 ? `${mb}MB` : `${mb.toFixed(1)}MB`;
    }
};
//获取文件类型
export const getFileTypeBySuffix = (suffix) => {
    let fileArr = ['pdf', 'docx', 'doc', 'txt', 'md', 'html', 'epub', 'xlsx', 'xls', 'csv', 'pptx', 'zip'];
    if (fileArr.includes(suffix)) {
        return fileTypeMap.file;
    }
    if (['mp4', 'avi', 'mov'].includes(suffix)) {
        return fileTypeMap.video;
    }
    if (['mp3', 'wav', 'aac'].includes(suffix)) {
        return fileTypeMap.audio;
    }
    return fileTypeMap.img;
};
export const isValidUrlByRegex = (url) => {
    let regex =
        /^https?:\/\/(?!.*\.\.)(?:[a-zA-Z0-9_][a-zA-Z0-9_-]{0,61}[a-zA-Z0-9_]\.)+[a-zA-Z0-9_][a-zA-Z0-9_-]{0,61}[a-zA-Z0-9_](?::[0-9]{1,5})?(?:\/[^\s]*)?$/;
    return regex.test(url);
};
export const isUrl = (str) => {
    if (isValidUrlByRegex(str)) {
        return true;
    }
    return false;

    // 使用 URL 构造函数精确验证
    // try {
    //     const parsed = new URL(str);
    //     // 仅允许 http 或 https 协议
    //     return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    // } catch {
    //     return false;
    // }
};
